import React from 'react';
import color from 'src/styles/themes/color';

type Props = {
  w?: number;
  h?: number;
  fill?: string;
  className?: string;
  onClick?: () => void;
};

const IconChevronRight: React.FC<Props> = ({
  w = 16,
  h = 17,
  fill = color.neutral_7,
  className,
  onClick,
}) => {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g clipPath="url(#clip0_14125_18533)">
        <path
          d="M5.33398 4.23792L6.27679 3.29297L10.9908 8.01775L6.27679 12.7425L5.33398 11.7976L9.10522 8.01775L5.33398 4.23792Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_14125_18533">
          <rect width="16" height="16.0364" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconChevronRight;
